var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isEmail && _vm.canBeRendered
    ? _c(
        "a",
        {
          staticClass: "conditional-link",
          attrs: { href: _vm.path, title: _vm.label }
        },
        [
          _vm._t("default", [
            _c("span", { domProps: { textContent: _vm._s(_vm.label) } })
          ])
        ],
        2
      )
    : _vm.isExternal && _vm.canBeRendered
      ? _c(
          "a",
          {
            staticClass: "conditional-link",
            attrs: {
              target: "_blank",
              rel: "noopener noreferrer",
              href: _vm.path,
              title: _vm.label
            }
          },
          [
            _vm._t("default", [
              _c("span", { domProps: { textContent: _vm._s(_vm.label) } })
            ])
          ],
          2
        )
      : _vm.isRouterLink && _vm.canBeRendered
        ? _c(
            "router-link",
            { attrs: { to: { path: _vm.path }, title: _vm.label } },
            [
              _vm._t("default", [
                _c("span", { domProps: { textContent: _vm._s(_vm.label) } })
              ])
            ],
            2
          )
        : _vm.canBeRendered
          ? _c(
              "span",
              [
                _vm._t("default", [
                  _c("span", { domProps: { textContent: _vm._s(_vm.label) } })
                ])
              ],
              2
            )
          : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64967010", { render: render, staticRenderFns: staticRenderFns })
  }
}